import OrderTemplate from './OrderTemplate';

export default OrderTemplate;
